import * as React from 'react';

interface RenderContourProps {
  data: { cyan: number,magenta: number,jaune: number,noir: number,hexadecimal: string}
}

export const RenderContour = (props: RenderContourProps) => {

  const contourData = props.data;

  return (
      <div>
        <span className="colorOpac">Contour: </span>
        <span>C: {contourData.cyan} M: {contourData.magenta} J: {contourData.jaune} N: {contourData.noir} </span>
        <span className={"pl-3 pr-3"} title={`C: ${contourData.cyan} M: ${contourData.magenta} J: ${contourData.jaune} N: ${contourData.noir}`}
              style={{border: "1px solid black", backgroundColor: `#${contourData.hexadecimal}`}}>&nbsp;</span>
      </div>
  );
}